import * as RTK from '@reduxjs/toolkit';
import { ModaSofa } from '@dora/backpack';

/**
 * A store to hold the sofa templates for each possible moda modular sofa.
 */

export type State = {
    templates: Record</** range */ string, ModaSofa.UnresolvedModularTemplate> | null;
};

// This is currently hard coded. Presumably it will come from a service or something one day. The
// dimensions are tweaked by hand to ensure that sofas look like a single piece with no gaps.
// UPDATE 5/4/22: we updated the layout method to use dimensionAdjustments and align by back of
// piece. A quick run through of Birkin/Talia/Salone was done to update their dimensions/adjustments
// to be acceptable for production but it was not exhaustive. So the data below may be slightly
// inaccurate.
// TODO: Ideally we should be taking dimensions from the model bounding boxes, not from here.
// Dimension adjustments can be done manually (or be inspecting the shape of the sofa in blender
// with a measuring tool).
const initialState: State = { templates: null };

const slice = RTK.createSlice({
    name: 'moda-sofa-templates',
    initialState,
    reducers: {
        setSofaTemplates(state, action: RTK.PayloadAction<State>) {
            return action.payload;
        },
    },
});

export const { setSofaTemplates } = slice.actions;

export const reducer = slice.reducer;
